import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import SettingsSidebar from "../../sidebar";
import { Alert, confirm } from "modules/theme";
import APIManager from "modules/common/apiManager";
import CarrierRateAddEdit from "./CarrierRateAddEdit";
import { Row, RowTitle, Box, BoxName, Divider } from "../../main/styles";
import { BarItems } from "modules/theme";
import { CustomDropdown } from "modules/common/components";
import {
  //DataWrapperClass,
  FilterContainer,
  FlexItem,
  FlexRow,
} from "../styles";
import { Modal, MenuItem } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";
import { PerPage } from "helpers/system-config";
import { FormWrapper, FormColumn } from "modules/theme";
import { ModalFooter } from "modules/theme";
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Label,
  Tip,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  ImportFile,
  SeachForm,
  OverflowClass,
  DataWrapperClass,
  ButtonCommonTheme,
} from "modules/theme";
import { leftSidebarType, modalType } from "../../../../../helpers/dotenv";
import { MdOutlineAdd } from "react-icons/md";

class CarrierRate extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `Carrier Rate`;
    this.moduleUrl = `setting/telephony`;
    this.mAPI = new APIManager();
    this.handleModalShowHide = this.handleModalShowHide.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.handleModalShowImport = this.handleModalShowImport.bind(this);
    this.getList = this.getList.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    const { telephonyId } = props;
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      showHide: false,
      modalType: modalType,
      file: "",
      showImport: false,
      search: "",
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      searchValue: "",
    };
  }

  search(e) {
    const value = e.target.value;
    // const reg = /^[a-zA-Z0-9_ @]*$/;
    // if (reg.test(value)) {
    if (value.trim() || value === "") {
      let teamList = this.state.listData.map((item) => ({
        ...item,
        selected: false,
      }));
      this.setState({
        SelectedList: [],
        MasterChecked: false,
        SingleChecked: false,
        listData: teamList,
        searchValue: value,
        currentPage: 1,
      });
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: encodeURIComponent(value.trim()) });
        this.getList(1, this.state.perPageCount, value);
      }, 500);
    }
    // }
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    // const ary = [];
    const list = this.state.SelectedList.map((data) => {
      // ary = data._id;
      this.state.ary.push(data._id);
      // this.setState({ ary: data._id });
    });
    this.mAPI.sendPostAPI(
      `${this.moduleUrl}/{telephonyId}/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        this.setState({
          SelectedList: [],
          MasterChecked: false,
          SingleChecked: false,
          currentPage: 1,
        });
        this.getList(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(
          `${this.moduleName}${
            data.modifiedCount > 1 ? "s" : ""
          } deleted successfully.`
        );
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  componentDidMount() {
    this.getList(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.search
    );
  }
  // breadcrumb(){
  //   return ;
  // }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  apiResponse(errorCode, data) {
    if (errorCode === 0) {
      let message = "File Successfully Updated.";
      // data && data.message ? data.message : 'Successfully updated';
      Alert.success(`${message}`);
    } else {
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(`${message}`);
    }
  }

  closeModal(isUpdated) {
    this.setState({ showHide: false });
    if (isUpdated) {
      this.getList(
        this.state.currentPage,
        this.state.perPageCount,
        this.state.search
      );
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  handleModalShowImport() {
    this.setState({ showImport: !this.state.showImport });
  }

  handleModalShowHide(data) {
    this.setState({ showHide: !this.state.showHide });
  }

  getList(page = 1, perPage = "", searchText = "") {
    const { telephonyId } = this.props;
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `${this.moduleUrl}/${telephonyId}/list?limit=${perPage}&page_no=${page}&search=${searchText}&orderBy=create_at&order=DESC`,
      (data) => {
        this.setState({ loading: false });
        if (data && data.data) {
          that.setState({
            listData: data.data.map((i) => ({
              ...i,
              selected: false,
            })),
            // listData: data.data,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
            MasterChecked: false,
          });
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page, MasterChecked: false });
    this.getList(page, this.state.perPageCount, this.state.search);
  }

  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getList(1, perPage, this.state.search);
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  deleteData(data) {
    const { telephonyId } = this.props;
    var that = this;
    this.mAPI.sendPostAPI(
      `${this.moduleUrl}/${telephonyId}/${data._id}`,
      undefined,
      (data) => {
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", data._id);
        const totalItemsOnCurrentPage = tD.length;
        if (totalItemsOnCurrentPage === 0 && that.state.currentPage > 1) {
          that.setState({ currentPage: 1 }, () => {
            that.getList(1, that.state.perPageCount, that.state.search);
          });
        } else {
          that.setState({ listData: tD });
          that.getList(
            that.state.currentPage,
            that.state.perPageCount,
            that.state.search
          );
        }
        // that.setState({ listData: tD });
        // this.getList(
        //   this.state.currentPage,
        //   this.state.perPageCount,
        //   this.state.search
        // );
        Alert.success(`${this.moduleName} deleted successfully.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  onChange() {}

  onSingleChange(e, company) {}

  edit(data) {
    return (
      /* <Tip text={`${'Edit'}`} key={`${'Edit'}`}>
      <Button
        btnStyle="link"
        onClick={() => this.openModal(data)}
        style={{ verticalAlign: 'middle' }}
        icon="edit"
      ></Button>
      </Tip> */
      <ButtonCommonTheme type="edit" editOnClick={() => this.openModal(data)} />
    );
  }

  renderActions(data, index) {
    return (
      <ActionButtons>
        {this.edit(data)}
        {/* <Tip text={`${'Delete'}`} key={`${'Delete'}`}>
          <Button
            btnStyle="link"
            onClick={e =>
              confirm().then(e => {
                this.deleteData(data, e);
              })
            }
            style={{ verticalAlign: 'middle' }}
          // icon={'user-minus'}
          >
            <FiTrash2 style={{ fontSize: '14px' }} />
          </Button>
        </Tip> */}
        {/* <ButtonCommonTheme type='delete' deleteOnClick={e =>
          confirm("Are you sure?",{url:'/images/icons/ic_delete_main.svg', isDeleted:true}).then(e => {
            this.deleteData(data, e);
          })
        } /> */}
        <CustomDropdown
          index={index}
          totalLength={this.state.listData.length || 0}
        >
          <MenuItem
            onClick={(e) =>
              confirm().then((e) => {
                this.deleteData(data, e);
              })
            }
          >
            {"Delete"}
          </MenuItem>
        </CustomDropdown>
      </ActionButtons>
    );
  }

  // importRate(e) {
  //   const { telephonyId } = this.props;
  //   let _this = this;
  //   e.preventDefault();
  //   let formData = new FormData();
  //   formData.append('file', this.state.file);

  //   this.mAPI.sendPostForm(
  //     `${this.moduleUrl}/${telephonyId}/report/import`,
  //     formData,
  //     data => {
  //       //Set the progress value to show the progress bar
  //       Alert.success(`File is added.`);
  //       this.handleModalShowImport();
  //       // this.resetAllData();
  //       this.getList();
  //     },
  //     (errorCode, data) => {
  //       this.apiResponse(errorCode, data);
  //     }
  //   );
  // }

  importContact(file) {
    let formData = new FormData();
    formData.append("file", file);
    // formData.append('contactListId', this.state.contactId);
    return formData;
  }

  renderActionBar() {
    let _this = this;
    /* const importTrigger = (
      <Button btnStyle="default" size="small">
        <img src='/images/plus.png' style={{ width: '12px' }} />
      </Button>
    ); */
    const ImportTrigger = ({ onClick }) => {
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    const { telephonyId } = this.props;
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        {/*  <SeachForm>
          <FormControl
            type="text"
            placeholder={'Search...'}
            onChange={e => this.search(e)}
            value={this.state.searchValue}
            autoFocus={false}
          />
        </SeachForm> */}
        <ModalTrigger
          title={this.moduleName}
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          dialogClassName={this.state.modalType}
        >
          <CarrierRateAddEdit
            size="small"
            update={() => this.setState({ currentPage: 1 })}
            isEdit={false}
            editData={this.state.editData}
            modalType={this.state.modalType}
            closeModal={this.closeModal}
            telephonyId={this.props}
          />
        </ModalTrigger>

        <ImportFile
          apiUrl={`${this.moduleUrl}/${telephonyId}/report/import`}
          fetchData={this.importContact}
          importDone={() => {
            _this.setState({ loading: true });
            setTimeout(() => {
              _this.onPerPageChooser(_this.state.perPageCount);
            }, 3000);
          }}
          urlDownload={`carrier-rate.csv`}
        ></ImportFile>

        {/* <Button
          btnStyle="default"
          size="small"
          icon="upload-6"
          onClick={() => this.handleModalShowImport()}
          style={{ marginLeft: '10px' }}
        >
          Import {this.moduleName}
        </Button> */}

        {/* <Modal show={this.state.showImport} className="center">
          <Modal.Body>
            <form onSubmit={e => this.importRate(e)}>
              <FormWrapper>
                <FormColumn>
                  {this.renderFormGroup('Bulk Upload DNC', {
                    defaultValue: '',
                    autoFocus: true,
                    componentClass: 'file',
                    type: 'file',
                    value: '',
                    accept: '.csv',
                    selectedFile: this.state.file,
                    onChange: e => {
                      if (e.target.files && e.target.files[0]) {
                        this.setState({ file: e.target.files[0] });
                      } else {
                        this.setState({ file: null });
                      }
                    },
                    id: 'file'
                  })}
                </FormColumn>
              </FormWrapper>

              <ModalFooter>
                <div style={{ textAlign: 'left', marginBottom: '5px' }}>
                  <Button
                    btnStyle="link"
                    size="small"
                    icon="folder-download"
                    target="_blank"
                    href={this.mAPI.downloadUrl('carrier-rate.csv')}
                  >
                    {'Download Sample File'}
                  </Button>
                </div>

                <Button
                  btnStyle="simple"
                  onClick={() => this.handleModalShowImport()}
                  icon="cancel-1"
                  size="small"
                  style={{ marginRight: '10px' }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  btnStyle="default"
                  icon="checked-1"
                  size="small"
                >
                  Save
                </Button>
              </ModalFooter>
            </form>
          </Modal.Body>
        </Modal> */}
      </span>
    );
  }

  render() {
    const { __ } = this.context;
    const { telephonyId } = this.props;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("Providers"), link: "/settings/providers" },
      {
        title: __("Carrier Rate"),
        link: `/settings/CarrierRate/${telephonyId}`,
      },
    ];

    const mainContent = (
      <DataWrapperClass overflow="auto" className="tableFixHeadSecondary">
        {/* <OverflowClass> */}
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th onClick={this.onClick}>
                <FormControl
                  componentClass="checkbox"
                  checked={this.state.MasterChecked}
                  onChange={(e) => this.onMasterCheck(e)}
                />
              </th>
              <th>{__("Dial Code")}</th>
              {/* <th>{__('Country Abbreviation')}</th> */}
              <th>{__("Destination")}</th>
              <th>{__("Rate")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody>
            {this.state.listData.map((data, index) => (
              <tr key={data._id}>
                <td onClick={this.onClick}>
                  <FormControl
                    componentClass="checkbox"
                    checked={data.selected}
                    onChange={(e) => this.onItemCheck(e, data)}
                  />
                </td>
                <td>{data.countryCode}</td>
                {/* <td>{data.startDate}</td> */}
                <td>{data.destination}</td>
                <td>{data.rate}</td>
                <td>{this.renderActions(data, index)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        {/* </OverflowClass> */}
      </DataWrapperClass>
    );

    const actionBarRight = (
      <div>
        <BarItems>
          <Button
            btnStyle="default"
            onClick={() => this.handleModalShowHide()}
            icon="checked-1"
          >
            Add
          </Button>
        </BarItems>
      </div>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={<ControlLabel>{`Carrier Rate`}</ControlLabel>}
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    <SeachForm className="mr-5">
                      <FormControl
                        type="text"
                        placeholder={"Search Here"}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                      <span class="material-symbols-outlined">search</span>
                    </SeachForm>
                    {/*  <ControlLabel>{`Carrier Rate (${this.state.total || 0})`}</ControlLabel> */}
                    {this.state.SelectedList.length > 0 ? (
                      /* <Tip text={`${'Delete'}`} key={`${'Delete'}`}>
                        <Button
                          btnStyle="danger"
                          size="small"
                          onClick={e =>
                            confirm().then(e => {
                              this.deleteAllData(e);
                            })
                          }
                          style={{
                            verticalAlign: 'middle',
                            marginLeft: '10px'
                          }}
                        // icon={'user-minus'}
                        >
                          <FiTrash2
                            style={{ fontSize: '14px', marginBottom: '-3px' }}
                          />
                        </Button>
                      </Tip> */
                      <ButtonCommonTheme
                        type="checkboxDelete"
                        checkboxDeleteOnClick={(e) =>
                          confirm("Are you sure?", {
                            url: "/images/icons/ic_delete_main.svg",
                            isDeleted: true,
                          }).then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    ) : (
                      ""
                    )}
                    {/* </FlexItem> */}
                    {/* <FlexItem>
                        <FormControl
                          placeholder={__('Search')}
                          name="searchValue"
                          onChange={e => this.search(e)}
                          value={this.state.searchValue}
                          autoFocus
                          // onFocus={this.moveCursorAtTheEnd}
                        />
                      </FlexItem> */}
                    {/* </FlexRow> */}
                    {/* </FilterContainer> */}
                  </div>
                }
                // right={actionBarRight}
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingsSidebar />}
            showLeftSideBar={leftSidebarType}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText={`Sorry..! No ${this.moduleName} Found`}
                  emptyImage="/images/empty/no_carrierrate.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

CarrierRate.contextTypes = {
  __: PropTypes.func,
};

export default CarrierRate;



// WEBPACK FOOTER //
// src/modules/screens/settings/CarrierRate/components/CarrierRate.js